export enum ReportNewClaimSteps {
  STEP_SELECT_STUDENT = 'STEP_SELECT_STUDENT',
  STEP_VIEW_STUDENT = 'STEP_VIEW_STUDENT',
  STEP_FILL_INSURANCE_INFORMATION = 'STEP_FILL_INSURANCE_INFORMATION',
  STEP_FILL_CLAIM_INFORMATION = 'STEP_FILL_CLAIM_INFORMATION',
  STEP_FILL_SIGNATURE = 'STEP_FILL_SIGNATURE',
  STEP_CLAIM_PREVIEW = 'STEP_CLAIM_PREVIEW'
}
